import { AUTHORIZE } from "../actions/types";
const initialState = {
  isLoggedIn: false,
};
export default function (state = initialState, action) {
  switch (action.type) {
    case AUTHORIZE:
      return {
        ...state,
        isLoggedIn: action.payload,
      };

    default:
      return state;
  }
}
